<template>
  <div class="ele-admin-layout ele-tabs-show ele-tab-dot">
    <!-- 头部内容 -->
    <div class="ele-admin-header" :style="{backgroundColor: $store.state.headerBGColor}">
      <div class="ele-admin-logo" :style="{display: isCollapse ? 'none':'flex'}"><span>Ustayz居澳优享</span></div>
      <el-menu class="el-menu--horizontal el-menu ele-header-left" mode="horizontal">
        <el-menu-item index="1" @click="isCollapse = !isCollapse"><i :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i></el-menu-item>
      </el-menu>
      <el-breadcrumb separator="/" class="ele-header-breadcrumb">
        <template v-for="(item,index) in $store.state.breadList">
          <el-breadcrumb-item :key="item.path" @click.native="changeTabs(item)">{{item.cName}}</el-breadcrumb-item>
        </template>
      </el-breadcrumb>
      <el-dropdown>
        <el-button :style="{ border:0,padding: 0}">
          <el-badge :value="$store.state.unreadNumber" class="item" :style="{marginRight:'10px'}">
            <i class="el-icon-message-solid" :style="{color: $store.state.noticeColor,fontSize:'20px'}"></i>
          </el-badge>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <template v-for="item in $store.state.userList"><el-dropdown-item><span @click="goMessage(item)">{{item.name == '' || item.name == null?item.id:item.name}}<span v-if="item.phone !=''">({{item.phone}})</span></span></el-dropdown-item></template>
        </el-dropdown-menu>
      </el-dropdown>

      <el-menu class="el-menu-demo el-header-right" mode="horizontal" @select="operationInformation">
        <el-submenu index="1">
          <template slot="title">{{ userName }}</template>
          <el-menu-item index="1-1"><i class="el-icon-edit"></i>修改密码</el-menu-item>
          <el-menu-item index="1-2"><i class="el-icon-delete"></i>退出登录</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <!-- 中间内容 -->
    <el-main>
      <!-- 左侧菜单栏 -->
      <el-aside :style="{width: isCollapse ? 'auto':'auto'}">
        <el-menu :default-active="$store.state.activeValue" class="ele-admin-sidebar el-menu-vertical-demo" :style="{width: isCollapse ? 'auto':'256px'}" :collapse="isCollapse" :unique-opened="true" :collapse-transition="true" @select="handleSelect" :active-text-color="$store.state.activeColor">
          <template v-for="(item) in $store.state.defaultList">
            <el-submenu v-if="item.children && item.children.length > 0" :key="item.index" :index="item.index">
              <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.groupItem }}</span>
              </template>
              <template v-for="childItem in item.children" >
                <el-menu-item-group :key="childItem.index">
                  <router-link :to="{ name: childItem.name }">
                    <el-menu-item :index="childItem.index">
                      <i :class="childItem.icon"></i>
                      <span slot="title">{{ childItem.navItem }}</span>
                    </el-menu-item>
                  </router-link>
                </el-menu-item-group>
              </template>
            </el-submenu>
            <el-menu-item v-else :key="item.index" :index="item.index">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.groupItem }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <!-- 右侧顶部tabs -->
      <el-row class="ele-admin-body">
        <div class="ele-admin-tabs">
          <el-tabs v-model="$store.state.editableTabsValue" type="card" @tab-click="tabClick" @tab-remove="tabRemove">
            <template v-for="(item, index) in $store.state.editableTabs">
              <el-tab-pane :key="item.name" :label="item.title" :name="item.name" :closable="item.closable"></el-tab-pane>
            </template>
          </el-tabs>
          <el-dropdown class="ele-tabs-drop" @command="handleCloseCommand">
          <span class=" el-dropdown-link">
            <i class="el-icon-arrow-down el-dropdown-selfdefine " aria-haspopup="list" aria-controls="dropdown-menu-4689" role="button" tabindex="0"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1"><i class="el-icon-close"></i>关闭其他</el-dropdown-item>
              <el-dropdown-item command="2"><i class="el-icon-right"></i>关闭右侧</el-dropdown-item>
              <el-dropdown-item command="3"><i class="el-icon-back"></i>关闭左侧</el-dropdown-item>
              <el-dropdown-item command="4"><i class="el-icon-circle-close"></i>关闭全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <transition name="fade" mode="out-in">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive">
              <!-- 这里是会被缓存的视图组件 -->
            </router-view>
          </keep-alive>
        </transition>
        <transition name="fade" mode="out-in">
          <router-view v-if="!$route.meta.keepAlive">
            <!-- 这里是不被缓存的视图组件 -->
          </router-view>
        </transition>
      </el-row>
    </el-main>
    <!-- 弹出框 -->
    <el-dialog title="修改密码" :visible.sync="cropperModel" width="950px" center :close-on-click-modal="false" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword" clearable placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="ruleForm.newPassword" clearable placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPasswordNext">
          <el-input type="password" v-model="ruleForm.newPasswordNext" clearable placeholder="请输入确认密码"></el-input>
        </el-form-item>
      </el-form>
      <!-- 保存 -->
      <div :style="{textAlign:'center'}">
        <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm('ruleForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 局部MD5引用
  import md5 from 'js-md5'
  export default {
    name: 'Public',
    data() {
      // 验证旧密码
      let validatePassword = (rule, value, callback) => {
        if (md5(value) !== window.atob(sessionStorage.getItem("userPass"))) {
          callback(new Error('旧密码输入错误!'));
        } else {
          callback();
        }
      };
      // 验证密码和确认密码
      let validatePassNext = (rule, value, callback) => {
        if (value !== this.ruleForm.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        isCollapse:false, // 控制显示全部菜单栏还是图标
        cropperModel:false, // 修改密码弹出框显示隐藏
        userName:"", // 用户名
        customerServiceNew:null,//storck
        randomNumber:'', // 随机数
        ruleForm: { // 表单
          oldPassword: "",// 原密码
          newPassword: "",// 新密码
          newPasswordNext: "",// 确认密码
        },
        rules: { // 表单验证信息
          oldPassword: [
            {required: true, message: '请输入原密码', trigger: 'blur'},
            {validator: validatePassword, trigger: 'blur'},
          ],
          newPassword: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
          ],
          newPasswordNext: [
            {required: true, message: '请输入确认密码', trigger: 'blur'},
            {validator: validatePassNext, trigger: 'blur'},
          ],
        },
      }
    },
    computed: { //监听词条
      getEditableTabsValue(){
        return this.$store.state.editableTabsValue;
      },
    },
    watch: {
      getEditableTabsValue: {
        handler(newValue){  //当词条改变时执行事件
          let that = this;
          this.$store.state.defaultList.forEach(function(item){
            if (item.children != undefined){
              item.children.forEach(function(child){
                if (child.name == newValue){
                  that.$store.dispatch('setActiveValue',child.index);
                }
              })
            } else {
              if (item.name == newValue){
                that.$store.dispatch('setActiveValue',item.index);
              }
            }
          })
        }
      },
    },
    methods: {
      // 切换菜单栏
      handleSelect(key){
        let exist = false;
        let that = this;
        this.$store.state.editableTabs.forEach(function(item){
          if (key == item.index){
            exist = true;
            that.$store.dispatch('setEditableTabsValue',item.name);
            that.$router.replace({path: item.path});
            that.$store.dispatch('setBreadList');
          }
        })
        if (!exist){
          let newTabName = "",newTabPath = "",title = "",choose = "";
          if (key.indexOf("-") > -1){ // 二级菜单
            let keyList = key.split("-");
            title = this.$store.state.defaultList[keyList[0]].children[keyList[1]].navItem;
            newTabName = this.$store.state.defaultList[keyList[0]].children[keyList[1]].name;
            newTabPath = this.$store.state.defaultList[keyList[0]].children[keyList[1]].path;
            choose = this.$store.state.defaultList[keyList[0]].children[keyList[1]].index;
          } else { // 一级菜单
            title = this.$store.state.defaultList[key].groupItem;
            newTabName = this.$store.state.defaultList[key].name;
            newTabPath = this.$store.state.defaultList[key].path;
            choose = this.$store.state.defaultList[key].index;
          }
          this.$store.dispatch('setPushCloseAllTabs',{ title: title,name: newTabName, path: newTabPath, index: choose, closable:true });
          this.$store.dispatch('setEditableTabsValue',newTabName);
          this.$router.replace({ path: newTabPath });
          this.$store.dispatch('setBreadList');
        }
      },
      // 移除选择的tabs
      tabRemove (targetName) {
        this.$store.dispatch('setCloseTab',targetName);
        this.chooseMenu(targetName);
        this.$router.replace({ path: this.$store.state.editableTabs[this.$store.state.editableTabs.length - 1].path });
        this.$store.dispatch('setBreadList');
      },
      // 切换tab，切换路由
      tabClick (tab) {
        this.chooseMenu(tab.name);
        this.$router.replace({ path: "/"+ tab.name });
        this.$store.dispatch('setBreadList');
      },
      // 菜单选中事件
      chooseMenu(activeName){
        let that = this;
        this.$store.state.editableTabs.forEach(function(item){
          if (item.name == activeName){
            that.$store.dispatch('setActiveValue',item.index);
          }
        })
      },
      // 关闭菜单
      handleCloseCommand(command){
        let that = this;
        if (command == 1){ // 关闭其他
          let currentMenu = {};
          this.$store.state.editableTabs.forEach(function(item){
            if (item.name == that.$store.state.editableTabsValue){
              currentMenu = item;
            }
          })
          this.$store.dispatch('setCloseAllTabs');
          if (currentMenu.name != "HousingManagementFullRent"){
            this.$store.dispatch('setPushCloseAllTabs',currentMenu);
          }
        } else if (command == 2){ // 关闭右侧
          this.$store.state.editableTabs.forEach(function(item,index){
            if (item.name == that.$store.state.editableTabsValue){
              that.$store.state.editableTabs.splice(index + 1,that.$store.state.editableTabs.length - [index + 1]);
            }
          })
        } else if (command == 3){ // 关闭左侧
          that.$store.state.editableTabs.forEach(function(item,index){
            if (item.name == that.$store.state.editableTabsValue){
              that.$store.state.editableTabs.splice(1,index - 1);
            }
          })
        } else if (command == 4){ // 关闭全部
          this.$store.dispatch('setCloseAllTabs');
          this.$store.dispatch('setEditableTabsValue',"HousingManagementFullRent");
          this.$router.replace({ path: "/HousingManagementFullRent" });
          this.chooseMenu("HousingManagementFullRent");
        }
        this.$store.dispatch('setBreadList');
      },
      // 更改选中tabs
      changeTabs(item){
        if (item.name == "" && item.path == ""){
          return;
        }
        this.$store.dispatch('setEditableTabsValue',item.name);
        this.$router.replace({ path: item.path });
        this.$store.dispatch('setBreadList');
      },
      // 判断是修改密码还是退出系统
      operationInformation(command) {
        if (command == "1-1") {
          this.cropperModel = true;
        } else if (command == "1-2") {
          this.$confirm('确定退出系统', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            window.sessionStorage.clear();
            this.$router.push({name: "SignIn"});
            return;
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消退出系统'
            });
          });
        }
      },
      // 关闭弹框前
      handleClose(){
        this.ruleForm = {
          oldPassword: "",// 原密码
          newPassword: "",// 新密码
          newPasswordNext: "",// 确认密码
        };
        this.$refs.ruleForm.resetFields();
        this.cropperModel = false;
      },
      // 提交修改密码信息
      onConfirm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.saveOrUpdateLogin({
              id: sessionStorage.getItem("userId"),
              name: sessionStorage.getItem("userName"),
              password: md5(this.ruleForm.newPasswordNext),
            }).then(res => {
              if (res.data.status == 200) {
                this.cropperModel = false;
                // 提示信息
                this.$message({
                  message: '修改密码成功,请重新登录！',
                  type: 'success'
                });
                sessionStorage.clear();
                this.$router.push({ name: "SignIn" });
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            })
          }
        });
      },
      // 跳转消息
      goMessage(data){
        const {href} = this.$router.resolve({path: '/Message',query:{ memberId: data.id,memberName:data.name,memberPortrait:data.portrait }})
        window.open(href,  '_blank');
      },
      // 获取未读消息数量
      getMessageNumber(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        },{
          "field":"senderIsUser",
          "fun":"eq",
          "value": "1"
        },{
          "field":"readed",
          "fun":"eq",
          "value": "0"
        }];
        this.$api.findMessage({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(async res => {
          if (res.data.status == 200) {
            let number = Number(res.data.data.total);
            this.$store.dispatch('setUnreadNumberValue',number);
            let list  = res.data.data.records,memberList = [];
            let userList = [];
            for (let i = 0; i < list.length; i++){
              memberList.push(list[i].memberId);
            }
            memberList = this.newArrFn(memberList);
            for (let i = 0; i < memberList.length; i++){
              let data = await this.getMemberName(memberList[i]);
              if (data != null){
                userList.push(data);
              }
            }
            this.$store.dispatch('setUserListValue',userList);
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      },
      // 数组去重
      newArrFn (arr) {
        return Array.prototype.filter.call(arr, function (item, index) {
          return arr.indexOf(item) === index
        })
      },
      // 根据memberId返回名字
      async getMemberName(id){
        let data = {};
        await this.$api.findMemberById({
          id:id,
        }).then(res => {
          if (res.data.status == 200) {
            data = res.data.data;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
        return data;
      },
      //初始化weosocket
      initWebSocket(){
        let char = "1234567890";
        for(let j = 1; j <= 4; j++){
          let i = parseInt(10*Math.random());
          this.randomNumber = this.randomNumber + char.charAt(i);
        }
        this.customerServiceNew = new WebSocket(wss_url+"/IM/cvUnreadNumber"+this.randomNumber);
        this.customerServiceNew.onmessage = this.websocketonmessage;
        this.customerServiceNew.onerror = this.websocketonerror;
        this.customerServiceNew.onclose = this.websocketonerror;
      },
      websocketonmessage(e) {
        console.log(e);
        this.$store.dispatch('setUnreadNumberValue',e.data);
        this.getMessageNumber(this.$store.state.memberId);
      },
      //连接建立失败重连
      websocketonerror(){
        this.customerServiceNew = new WebSocket(wss_url+"/IM/cvUnreadNumber"+this.randomNumber);
        this.customerServiceNew.onmessage = this.websocketonmessage;
        this.customerServiceNew.onerror = this.websocketonerror;
        this.customerServiceNew.onclose = this.websocketonerror;
      },
    },
    mounted() {
      document.body.style.setProperty('--activeColor', this.$store.state.activeColor);
      document.body.style.setProperty('--activeBGColor', this.$store.state.activeBGColor);
      this.$store.dispatch('setEditableTabsValue',"HousingManagementFullRent");
      this.$router.replace({ path: "/HousingManagementFullRent" });
      let that = this;
      that.getMessageNumber();
      that.initWebSocket();
      setTimeout(function(){
        that.userName = sessionStorage.getItem("userName");
      },200);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/public.css"; /* 管理平台样式 */
</style>
     



// WEBPACK FOOTER //
// src/components/Common/Public.vue